import { departmentsSection } from '@stereoagency/sanity-schema';
import { $globalSanityClient } from '@/sanity';
import { profilesQuery } from './profilesQuery';
import UIDepartmentsSection from './DepartmentsSection.client';
import extractAllProfilesFromDepartments from './extractAllProfilesFromDepartments';

type Props = typeof departmentsSection.schema.departmentsSection;

export default async function DepartmentsSection({
  title,
  subtitle,
  departments
}: Props) {
  const profileIds = extractAllProfilesFromDepartments(departments ?? []);

  const profiles = await $globalSanityClient.fetch<(typeof profilesQuery)[1]>(
    profilesQuery[0],
    { ids: profileIds }
  );

  return (
    <UIDepartmentsSection
      title={title}
      subtitle={subtitle}
      departments={departments}
      profiles={profiles}
    />
  );
}
